//查询需要订阅的奖品信息
import wx from "weixin-js-sdk";
export function queryNeedNotifyAwardInfo(params, that) {
  that.$api.post({
    sc: "mobileMarketing",
    url: "miniActivityController/getUserWxSubscribeMsgTemplateId",
    params: params,
    success: r => {
      let needNotifyRewardsInfo = [];
      if (r && r.code === 200) {
        needNotifyRewardsInfo = r.result || [];
      } else {
        needNotifyRewardsInfo = [];
      }
      if (needNotifyRewardsInfo.length > 0) {
        needNotifyRewardsInfo = JSON.stringify(needNotifyRewardsInfo);
        wx.miniProgram.navigateTo({
          url: `/subpackages/activity/pages/activityH5Notify/activity-h5-notify?notifyType=expire&bigWheelActivityType=${
            params[0].bigWheelActivityType
          }&needNotifyRewardsInfo=${encodeURIComponent(needNotifyRewardsInfo)}`
        });
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/commons/commonJudgeIsNeedNotify.js